import React, { useState, useEffect } from 'react';
import { useNotaire } from "../context/NotaireContext";
import { FolderIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';
import EmptyState from './EmptyState';
import ModalAcceptationAffaire from './ModalAcceptationAffaire';
import { FaceSmileIcon, HeartIcon, TagIcon, HomeIcon } from '@heroicons/react/24/solid';
import { CheckBadgeIcon } from '@heroicons/react/24/outline';

export default function AllAffaires() {
  const context = useNotaire();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [idAffaire, setIdAffaire] = useState("");
  const [affaires, setAffaires] = useState([]);

  const openModalAcceptationAffaire = (id) => {
    setIdAffaire(id);
    setIsModalOpen(true);
  };

  const searchAffaire = (searchTerm) => {
    const lowerSearch = searchTerm.toLowerCase();

    if (searchTerm === "") {
      initList();

      return
    }

    let tempAffaires = [];
    let filteredAffaire = {};

    tempAffaires["mariage"] = context["mariage"]
    tempAffaires["pacs"] = context["pacs"];
    tempAffaires["pma"] = context["pma"];
    tempAffaires["certification"] = context["certification"];
    tempAffaires["immo"] = context["immo"];

    for (const key in tempAffaires) {
      //console.log(key);
      const filteredList = tempAffaires[key].filter(item => {
        //console.log(item.fields.nom);
        if (item.fields.nom !== undefined && item.fields.nom !== null) {
          return item.fields.nom.toLowerCase().includes(lowerSearch)
        } else if (item.fields.nom_from_user !== undefined && item.fields.nom_from_user !== null) {
          return item.fields.nom_from_user[0].toLowerCase().includes(lowerSearch)
        } else {
          return false;
        }
      }
      );

      filteredAffaire[key] = filteredList;
      // setAffaires
    }
    //console.log(filteredAffaire)

    setAffaires(filteredAffaire);
  };

  function initList() {
    setAffaires([])
    let tempAffaires = [];

    tempAffaires["mariage"] = context["mariage"]
    tempAffaires["pacs"] = context["pacs"];
    tempAffaires["pma"] = context["pma"];
    tempAffaires["certification"] = context["certification"];
    tempAffaires["immo"] = context["immo"];

    //console.log(tempAffaires);
    setAffaires(tempAffaires)
  }

  useEffect(() => {
    initList();
  }, []);




  const noAffaires =
    !context.immo?.length &&
    !context.pma?.length &&
    !context.mariage?.length &&
    !context.pacs?.length &&
    !context.certification?.length &&
    !context.aucuneDemarche?.length;

  const allTypes = [
    { key: "immo", label: "Immobilier", badgeClass: "badge-vendeur", fieldName: "nom", route: "immo", icon: HomeIcon },
    { key: "pma", label: "PMA", badgeClass: "badge-acheteur", fieldName: "nom_from_user", route: "pma", icon: FaceSmileIcon },
    { key: "mariage", label: "Contrat de mariage", badgeClass: "badge-notaire", fieldName: "nom_from_user", route: "mariage", icon: HeartIcon },
    { key: "pacs", label: "PACS", badgeClass: "badge-autre-notaire", fieldName: "nom_from_user", route: "pacs", icon: HeartIcon },
    { key: "certification", label: "Certification", badgeClass: "badge-notaire", fieldName: "nom_from_user", route: "certification", icon: CheckBadgeIcon },
    { key: "aucuneDemarche", label: "Aucune catégorie", badgeClass: "badge-autre-notaire", fieldName: "nom_from_user", route: "aucune_demarche", icon: TagIcon },
  ];

  function AffaireRowList({ data, label, badgeClass, fieldName, route, openModalAcceptationAffaire, isModalOpen, setIsModalOpen, icon: Icon, }) {
    return data?.length > 0 && data
      .filter((affaire) => affaire.fields.statut_marketplace_notaire !== "cloturée")
      .map((affaire) => (
        <tr key={affaire.id}>
          <td className="whitespace-nowrap py-3 pl-4 pr-3 text-sm sm:pl-0 items-center">
            <div className="flex items-center">
              <FolderIcon className="text-slate-400 size-6 ml-4" />
              <div className="font-bold text-gray-900 ml-2">{affaire.fields[fieldName]}</div>
            </div>
          </td>
          <td className="whitespace-nowrap px-3 py-3 text-sm text-gray-500">
            <div className={badgeClass}>
              {Icon && <Icon className="size-5 text-gray-500" />}

              {label}
            </div>
          </td>
          <td className="whitespace-nowrap px-3 py-3 text-sm text-gray-500">
            {affaire.fields.provenance === "interne" && <>
                            <span className="inline-flex items-center rounded-md  px-2 py-1 text-xs font-bold">
                                Interne
                              </span>
                            </>
                            }
                            {affaire.fields.provenance === "clotere" && <>
                            <span className="inline-flex items-center rounded-md  px-2 py-1 text-xs font-bold">
                                Clotere
                              </span>
                            </>
                            }
                            {affaire.fields.provenance === "partenaire" && <>
                            <span className="inline-flex items-center rounded-md  px-2 py-1 text-xs font-bold">
                                Partenaire
                              </span>
                            </>
                            }
          </td>
          <td className="whitespace-nowrap px-3 py-3 text-sm text-gray-500">
            <div className="flex items-center justify-end gap-x-2 sm:justify-start">
              {affaire.fields.statut_marketplace_notaire === "vérification avant attribution" && (
                <>
                  <div className="text-orange-400 bg-orange-400/10 flex-none rounded-full p-1">
                    <div className="size-1.5 rounded-full bg-current" />
                  </div>
                  <div className="hidden text-slate-500 sm:block">Nouvelle affaire 🚀</div>
                </>
              )}
              {affaire.fields.statut_marketplace_notaire === "notaire trouvé" && (
                <>
                  <div className="text-green-400 bg-green-400/10 flex-none rounded-full p-1">
                    <div className="size-1.5 rounded-full bg-current" />
                  </div>
                  <div className="hidden text-slate-500 sm:block">Dossier en cours</div>
                </>
              )}
            </div>
          </td>
          <td className="relative whitespace-nowrap py-3 pl-3 pr-4 text-center text-sm font-medium sm:pr-0">
            {affaire.fields.statut_marketplace_notaire === "vérification avant attribution" ? (
              <>
                <Link
                  className="btn-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    openModalAcceptationAffaire(affaire.id);
                  }}
                >
                  Prendre en charge
                </Link>
                {isModalOpen && (
                  <ModalAcceptationAffaire
                    type={route}
                    idAffaire={affaire.id}
                    onClose={() => setIsModalOpen(false)}
                  />
                )}
              </>
            ) : (
              <Link className="btn-main" to={`/app/affaire/${route}/${affaire.id}`}>
                Voir
              </Link>
            )}
          </td>
        </tr>
      ));
  }

  const rows = allTypes.flatMap((type) =>
    (affaires[type.key] || []).map((affaire) => ({
      affaire,
      meta: type,
    }))
  );

  const limitedRows = rows.slice(0, 5);
  const hasMore = rows.length > 5;
  return (
    <>
      {noAffaires ? (
        <div className="overflow-hidden rounded-lg bg-white shadow-sm mt-3 text-center">
          <EmptyState
            icon={FolderIcon}
            title="Aucune affaire en cours"
            description=""
          />
        </div>
      ) : (
        <div className="">
          {/**
          <Input
            id="nom"
            name="nom"
            type="text"
            placeholder="Rechercher une affaire.."
            className='mt-4'
            onChange={(val) => {
              searchAffaire(val.target.value);
            }}

          /> */}
          <div className="mt-2 flow-root">
            <div className="overflow-x-auto">
              <div className="inline-block min-w-full align-middle">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                        Nom
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Catégorie
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Provenance
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Statut
                      </th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                        <span className="sr-only">#</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {limitedRows.map(({ affaire, meta }, index) => (
                      <AffaireRowList
                        key={`${meta.key}-${index}`}
                        data={[affaire]}
                        label={meta.label}
                        badgeClass={meta.badgeClass}
                        fieldName={meta.fieldName}
                        route={meta.route}
                        openModalAcceptationAffaire={openModalAcceptationAffaire}
                        isModalOpen={isModalOpen}
                        setIsModalOpen={setIsModalOpen}
                      />
                    ))}
                  </tbody>


                </table>
                {hasMore && (
                  <div className="flex mx-auto justify-center mt-4">
                    <Link
                      to="/app/affaires"
                      className="btn-main"
                    >
                      Voir toutes les affaires
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

